// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.

import $ from 'jquery'
import Swiper from 'swiper/bundle';

'use strict';

const front_swiper = new Swiper('.front-swiper-container', {
  autoplay: {
    delay: 7500
  },
  direction: 'horizontal',
  slidesPerView: 1,
  speed: 1000,
  draggable: true,
  pagination: {
    el: '.swiper-pagination-front',
    clickable: true,
    type: 'bullets'
  },
  navigation: {
    nextEl: '.swiper-button-next-front',
    prevEl: '.swiper-button-prev-front'
  },
  loop: true
});

const review_swiper = new Swiper('.review-swiper-container', {
  autoplay: {
    delay: 5000
  },
  direction: 'horizontal',
  slidesPerView: 1,
  speed: 1000,
  draggable: true,
  pagination: {
    el: '.swiper-pagination-review',
    clickable: true,
    type: 'bullets'
  },
  navigation: {
    nextEl: '.swiper-button-next-review',
    prevEl: '.swiper-button-prev-review'
  },
  loop: true
});

const partner_swiper = new Swiper('.partner-swiper-container', {
  autoplay: {
    delay: 2000
  },
  direction: 'horizontal',
  slidesPerView: 4,
  speed: 750,
  draggable: true,
  loop: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // when window width is >= 480px
    576: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 30
    },
    // when window width is >= 640px
    1920: {
      slidesPerView: 6,
      spaceBetween: 40
    }
  }
});

// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
const breakpoint = window.matchMedia( '(min-width:576px)' );
// keep track of swiper instances to destroy later
let team_swiper;

const breakpointChecker = function() {
  // if larger viewport and multi-row layout needed
  if ( breakpoint.matches === true ) {
    // clean up old instances and inline styles when available
    if ( team_swiper !== undefined ) team_swiper.destroy( true, true );
    // or/and do nothing
    return;
    // else if a small viewport and single column layout needed
  } else if ( breakpoint.matches === false ) {
    // fire small viewport version of swiper
    return enableSwiper();
  }
};

const enableSwiper = function() {
  team_swiper = new Swiper ('.team-swiper-container', {
    loop: true,
    autoplay: {
      delay: 5000
    },
    slidesPerView: '1',
    centeredSlides: true,
    a11y: true,
    speed: 1000,
    draggable: true,
    keyboardControl: true,
    grabCursor: true
  });
};

// keep an eye on viewport size changes
breakpoint.addListener(breakpointChecker);
// kickstart
breakpointChecker();

$(document).ready(function(){
  $('.hamburger').click(function(){
    $(this).toggleClass('is-active');
    $('.main-menu').toggleClass('is-active');
    $('body').toggleClass('fixed');
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js